module.exports = __webpack_public_path__ + "static/media/results_automated_charts.50280ef5.png";